import * as React from 'react'

import { observer } from 'mobx-react'

import { useMemo } from 'modules/core/hooks/useMemo'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'
import { Process } from 'modules/processes/hooks/useProcesses'

import InvitationAccepted from './InvitationAccepted'
import InvitationAcceptedWithoutOnboarding from './InvitationAcceptedWithoutOnboarding'
import InvitationNotSentOrAccepted from './InvitationNotSentOrAccepted'

interface Props {
  employee: Employee
  onboardingProcess?: Process
}

const EmployeeStatusBanner = ({ employee, onboardingProcess }: Props) => {
  const [onboardingCreated, setOnboardingCreated] = React.useState<Process>()
  const user = employeeUser(employee)

  const invitationSentAndAccepted = user.invited && user.confirmed

  const banner = useMemo(() => {
    if (invitationSentAndAccepted) {
      if (onboardingProcess || onboardingCreated) {
        return (
          <InvitationAccepted
            employee={employee}
            onboardingProcess={onboardingProcess || onboardingCreated}
          />
        )
      }

      return (
        <InvitationAcceptedWithoutOnboarding
          employee={employee}
          setOnboardingProcessCreated={setOnboardingCreated}
        />
      )
    }

    if (!invitationSentAndAccepted) return <InvitationNotSentOrAccepted employee={employee} />

    return null
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitationSentAndAccepted, employee.id, onboardingCreated])

  if (banner === null) return null

  return banner
}

export default observer(EmployeeStatusBanner)
